export default "__VITE_ASSET__677c950a__"